<template>
	<div class="ro-livechat-floating" v-if="visible">
		<button
			type="button"
			class="ro-livechat-trigger"
			:class="{ 'is-disabled': !canOpenLiveChat }"
			:disabled="loading"
			@click="openLiveChat"
		>
			<span class="ro-livechat-trigger__icon">?</span>
			<span class="ro-livechat-trigger__text">{{ canOpenLiveChat ? (livechat.button_text || '在线客服') : '客服离线' }}</span>
		</button>
		<div class="ro-livechat-offline-tip" v-if="showOfflineTip">客服时间：工作日上午9:00~12:00，下午3:00~5:30</div>
		<div class="ro-livechat-dialog-mask" v-if="offlineDialogVisible">
			<div class="ro-livechat-offline-dialog">
				<div class="ro-livechat-offline-dialog__title">客服暂时离线</div>
				<div class="ro-livechat-offline-dialog__content">
					<p>{{ serviceHint || '当前没有在线客服' }}</p>
					<p>客服时间：工作日上午9:00~12:00，下午3:00~5:30</p>
				</div>
				<button type="button" @click="offlineDialogVisible = false">知道了</button>
			</div>
		</div>
		<div class="ro-livechat-popover" v-if="fallbackLoaded" v-show="fallbackOpen">
			<div class="ro-livechat-popover__header">
				<span>{{ livechat.button_text || '在线客服' }}</span>
				<button type="button" class="ro-livechat-popover__close" @click="closeFallbackLiveChat">x</button>
			</div>
			<div class="ro-livechat-popover__body">
				<div class="ro-livechat-messages" ref="messagesBox">
					<div class="ro-livechat-loading-text" v-if="messageLoading && messages.length == 0">正在连接在线客服...</div>
					<div class="ro-livechat-empty" v-else-if="messages.length == 0">请在下方输入您的问题，并按回车键。</div>
					<div
						class="ro-livechat-message"
						:class="{ 'is-self': item.is_self }"
						v-for="item in messages"
						:key="item.id"
					>
						<div class="ro-livechat-message__meta">
							<span>{{ item.author_name }}</span>
							<em>{{ item.date }}</em>
						</div>
						<div class="ro-livechat-message__body">{{ item.body }}</div>
					</div>
				</div>
				<div class="ro-livechat-input">
					<textarea
						v-model="draftMessage"
						:disabled="sending"
						placeholder="写些什么..."
						@keydown.enter.exact.prevent="sendMessage"
					></textarea>
					<button type="button" :disabled="sending || !draftMessage.trim()" @click="sendMessage">发送</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { fetchPost } from "../../utils/request"

export default {
	name: "rolivechatservice",
	data: function() {
		return {
			loading: false,
			messageLoading: false,
			sending: false,
			fallbackOpen: false,
			fallbackLoaded: false,
			offlineDialogVisible: false,
			messages: [],
			draftMessage: '',
			pollingTimer: null,
			livechat: {
				enabled: false
			}
		}
	},
	watch: {
		'$route': function() {
			this.getLiveChatConfig()
		}
	},
	computed: {
		visible: function() {
			return this.livechat && this.livechat.enabled
		},
		canOpenLiveChat: function() {
			if(!this.livechat || !this.livechat.enabled){
				return false
			}
			if(this.livechat.login_required){
				return true
			}
			return this.livechat.available !== false
		},
		showOfflineTip: function() {
			if(!this.livechat || !this.livechat.enabled || this.livechat.login_required){
				return false
			}
			return this.livechat.operator_count === 0 || this.livechat.available === false
		},
		serviceHint: function() {
			if(!this.livechat || !this.livechat.enabled){
				return ''
			}
			if(this.livechat.login_required){
				return this.livechat.hint || '请先登录或注册后使用在线客服'
			}
			if(this.livechat.operator_count === 0){
				return '该频道还没有客服人员'
			}
			if(this.livechat.available === false){
				return '当前没有在线客服'
			}
			return this.livechat.hint || '联系在线客服'
		}
	},
	created: function() {
		this.getLiveChatConfig()
	},
	beforeDestroy: function() {
		this.stopPolling()
	},
	methods: {
		getAuthParams: function() {
			return {
				id: window.localStorage.getItem('eshop_user_id'),
				session_id: window.localStorage.getItem('eshop_session_id'),
				livechat_token: window.localStorage.getItem('eshop_livechat_token')
			}
		},
		getLiveChatConfig: function() {
			this.loading = true
			var data = this.getAuthParams()
			return fetchPost('/ro/web_eshop/livechat/config/v1', data).then(response => {
				this.loading = false
				if(response.data.result == 'success'){
					var previousKey = this.getLiveChatKey(this.livechat)
					this.livechat = response.data.livechat || { enabled: false }
					var currentKey = this.getLiveChatKey(this.livechat)
					if(previousKey && currentKey && previousKey != currentKey){
						this.resetLiveChatWidget()
					}
				}
			}).catch(error => {
				this.loading = false
				console.log(error)
				throw error
			})
		},
		getLiveChatKey: function(livechat) {
			if(!livechat || !livechat.enabled){
				return ''
			}
			return livechat.base_url + ':' + livechat.channel_id + ':' + (livechat.web_user_id || '') + ':' + (livechat.visitor_label || livechat.visitor_name || '')
		},
		openLiveChat: function() {
			if(!this.canOpenLiveChat){
				this.offlineDialogVisible = true
				return
			}
			if(this.livechat && this.livechat.login_required){
				this.showLoginRequired()
				return
			}
			if(this.fallbackOpen){
				this.closeFallbackLiveChat()
				return
			}
			this.loading = true
			this.getLiveChatConfig().then(function() {
				this.openFallbackLiveChat()
			}.bind(this)).catch(function() {
				this.openFallbackLiveChat()
			}.bind(this))
		},
		openFallbackLiveChat: function() {
			if(this.livechat && this.livechat.login_required){
				this.loading = false
				this.showLoginRequired()
				return
			}
			this.fallbackOpen = true
			this.fallbackLoaded = true
			this.loading = false
			this.loadMessages()
			this.startPolling()
		},
		closeFallbackLiveChat: function() {
			this.fallbackOpen = false
			this.stopPolling()
		},
		loadMessages: function() {
			if(!this.livechat || this.livechat.login_required){
				return Promise.resolve()
			}
			this.messageLoading = true
			return fetchPost('/ro/web_eshop/livechat/messages/v1', this.getAuthParams()).then(response => {
				this.messageLoading = false
				if(response.data.result == 'success'){
					this.messages = response.data.messages || []
					this.$nextTick(this.scrollMessagesToBottom)
					return
				}
				if(response.data.result == 'login_required' || response.data.result == 'session_expired'){
					this.resetLiveChatWidget()
					this.showLoginRequired()
					return
				}
				if(response.data.reason){
					this.$message.warning(response.data.reason)
				}
			}).catch(error => {
				this.messageLoading = false
				console.log(error)
			})
		},
		sendMessage: function() {
			var message = this.draftMessage.trim()
			if(!message || this.sending){
				return
			}
			this.sending = true
			var data = this.getAuthParams()
			data.message = message
			fetchPost('/ro/web_eshop/livechat/send/v1', data).then(response => {
				this.sending = false
				if(response.data.result == 'success'){
					this.draftMessage = ''
					this.messages = response.data.messages || []
					this.$nextTick(this.scrollMessagesToBottom)
					return
				}
				if(response.data.result == 'login_required' || response.data.result == 'session_expired'){
					this.resetLiveChatWidget()
					this.showLoginRequired()
					return
				}
				this.$message.warning(response.data.reason || '消息发送失败')
			}).catch(error => {
				this.sending = false
				console.log(error)
				this.$message.error('消息发送失败')
			})
		},
		startPolling: function() {
			this.stopPolling()
			this.pollingTimer = window.setInterval(this.loadMessages, 5000)
		},
		stopPolling: function() {
			if(this.pollingTimer){
				window.clearInterval(this.pollingTimer)
				this.pollingTimer = null
			}
		},
		scrollMessagesToBottom: function() {
			var box = this.$refs.messagesBox
			if(box){
				box.scrollTop = box.scrollHeight
			}
		},
		showLoginRequired: function() {
			this.$confirm('为了保证沟通记录可溯源，请先登录或注册后使用在线客服。', '请先登录', {
				confirmButtonText: '去登录',
				cancelButtonText: '去注册',
				distinguishCancelAndClose: true,
				type: 'warning'
			}).then(function() {
				this.$router.push('/pages/login')
			}.bind(this)).catch(function(action) {
				if(action == 'cancel'){
					this.$router.push('/home/register')
				}
			}.bind(this))
		},
		resetLiveChatWidget: function() {
			this.stopPolling()
			this.fallbackOpen = false
			this.fallbackLoaded = false
			this.messages = []
			this.draftMessage = ''
			if(window.livechat_button && window.livechat_button.destroy){
				try {
					window.livechat_button.destroy()
				} catch(error) {
					console.log(error)
				}
			}
			window.livechat_button = null
			window.__ro_livechat_key = null
			window.__ro_livechat_loader_load_callbacks = []
			var nativeButton = document.querySelector('.o_livechat_button')
			if(nativeButton && nativeButton.parentNode){
				nativeButton.parentNode.removeChild(nativeButton)
			}
			var oldScripts = document.querySelectorAll('script[data-ro-livechat], link[data-ro-livechat]')
			for(var i = 0; i < oldScripts.length; i++){
				if(oldScripts[i].parentNode){
					oldScripts[i].parentNode.removeChild(oldScripts[i])
				}
			}
		},
		logout: function() {
			window.localStorage.setItem('eshop_user_id', false)
			window.localStorage.setItem('phone', false)
			window.localStorage.setItem('eshop_session_id', false)
			window.localStorage.setItem('eshop_livechat_token', false)
			this.$router.push("/pages/login")
		}
	}
}
</script>

<style scoped>
.ro-livechat-floating {
	position: fixed;
	right: 18px;
	top: 50%;
	transform: translateY(-50%);
	z-index: 3000;
	text-align: left;
}

.ro-livechat-trigger {
	display: flex;
	align-items: center;
	gap: 8px;
	min-width: 106px;
	height: 44px;
	padding: 0 13px;
	border: 0;
	border-radius: 22px 0 0 22px;
	background: #18b9d6;
	color: #fff;
	box-shadow: 0 8px 20px rgba(17, 97, 130, .22);
	cursor: pointer;
	font-size: 14px;
	font-weight: 700;
	line-height: 1;
}

.ro-livechat-trigger.is-disabled {
	background: #9aa3ad;
	cursor: not-allowed;
}

.ro-livechat-trigger__icon {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	width: 24px;
	height: 24px;
	border-radius: 50%;
	background: rgba(255, 255, 255, .22);
	font-size: 16px;
	font-weight: 800;
}

.ro-livechat-trigger__text {
	white-space: nowrap;
}

.ro-livechat-offline-tip {
	width: 220px;
	margin-top: 8px;
	margin-left: auto;
	padding: 7px 10px;
	border-radius: 4px;
	background: rgba(255, 255, 255, .96);
	color: #606266;
	box-shadow: 0 6px 18px rgba(17, 97, 130, .16);
	font-size: 12px;
	line-height: 1.5;
	text-align: left;
	box-sizing: border-box;
}

.ro-livechat-dialog-mask {
	position: fixed;
	left: 0;
	right: 0;
	top: 0;
	bottom: 0;
	z-index: 4100;
	display: flex;
	align-items: center;
	justify-content: center;
	background: rgba(0, 0, 0, .28);
}

.ro-livechat-offline-dialog {
	width: 420px;
	max-width: calc(100vw - 32px);
	padding: 28px 30px 24px;
	border-radius: 6px;
	background: #fff;
	box-shadow: 0 16px 42px rgba(0, 0, 0, .24);
	text-align: center;
	box-sizing: border-box;
}

.ro-livechat-offline-dialog__title {
	margin-bottom: 16px;
	color: #2f5597;
	font-size: 22px;
	font-weight: 700;
	line-height: 1.4;
}

.ro-livechat-offline-dialog__content {
	margin-bottom: 24px;
	color: #303133;
	font-size: 16px;
	line-height: 1.8;
}

.ro-livechat-offline-dialog__content p {
	margin: 0;
}

.ro-livechat-offline-dialog button {
	min-width: 108px;
	height: 40px;
	border: 0;
	border-radius: 4px;
	background: #18b9d6;
	color: #fff;
	font-size: 15px;
	font-weight: 700;
	cursor: pointer;
}

.ro-livechat-popover {
	position: absolute;
	right: 0;
	top: 50%;
	width: 390px;
	height: 560px;
	max-height: calc(100vh - 32px);
	transform: translateY(-50%);
	background: #fff;
	border: 1px solid #dcdfe6;
	border-radius: 5px;
	box-shadow: 0 10px 28px rgba(0, 0, 0, .2);
	overflow: hidden;
}

.ro-livechat-popover__header {
	height: 44px;
	line-height: 44px;
	padding: 0 12px 0 16px;
	background: #2f5597;
	color: #fff;
	font-size: 15px;
	font-weight: 700;
	text-align: left;
	box-sizing: border-box;
}

.ro-livechat-popover__close {
	float: right;
	width: 28px;
	height: 28px;
	margin-top: 8px;
	border: 0;
	background: transparent;
	color: #fff;
	font-size: 18px;
	line-height: 28px;
	cursor: pointer;
}

.ro-livechat-popover__body {
	display: flex;
	flex-direction: column;
	width: 100%;
	height: calc(100% - 44px);
	background: #fff;
}

.ro-livechat-messages {
	flex: 1;
	overflow-y: auto;
	padding: 12px;
	background: #f7f9fc;
	box-sizing: border-box;
}

.ro-livechat-loading-text,
.ro-livechat-empty {
	padding-top: 120px;
	color: #909399;
	font-size: 14px;
	text-align: center;
}

.ro-livechat-message {
	max-width: 82%;
	margin-bottom: 12px;
}

.ro-livechat-message.is-self {
	margin-left: auto;
	text-align: right;
}

.ro-livechat-message__meta {
	margin-bottom: 4px;
	color: #7f8a9b;
	font-size: 12px;
	line-height: 1.4;
}

.ro-livechat-message__meta em {
	margin-left: 6px;
	color: #a7b0bf;
	font-style: normal;
}

.ro-livechat-message__body {
	display: inline-block;
	padding: 8px 10px;
	border-radius: 5px;
	background: #fff;
	color: #303133;
	font-size: 14px;
	line-height: 1.6;
	text-align: left;
	white-space: pre-wrap;
	word-break: break-word;
	box-shadow: 0 1px 3px rgba(31, 45, 61, .1);
}

.ro-livechat-message.is-self .ro-livechat-message__body {
	background: #dff3ff;
}

.ro-livechat-input {
	display: flex;
	gap: 8px;
	padding: 8px;
	border-top: 1px solid #dcdfe6;
	background: #fff;
	box-sizing: border-box;
}

.ro-livechat-input textarea {
	flex: 1;
	height: 44px;
	min-width: 0;
	padding: 7px 9px;
	border: 1px solid #dcdfe6;
	border-radius: 4px;
	color: #303133;
	font-size: 14px;
	line-height: 1.4;
	resize: none;
	outline: none;
	box-sizing: border-box;
	font-family: Arial, "Microsoft YaHei", sans-serif;
}

.ro-livechat-input textarea:focus {
	border-color: #18b9d6;
}

.ro-livechat-input button {
	width: 58px;
	height: 44px;
	border: 0;
	border-radius: 4px;
	background: #18b9d6;
	color: #fff;
	font-size: 14px;
	font-weight: 700;
	cursor: pointer;
}

.ro-livechat-input button:disabled {
	background: #c0c4cc;
	cursor: not-allowed;
}

@media (max-width: 640px) {
	.ro-livechat-floating {
		right: 0;
	}

	.ro-livechat-popover {
		position: fixed;
		left: 10px;
		right: 10px;
		top: 50%;
		width: auto;
		height: 76vh;
		transform: translateY(-50%);
	}
}
</style>
